import React, { useState, useEffect, useCallback } from 'react';

const DIAS = [
  { id: 0, label: 'Dom' }, { id: 1, label: 'Seg' }, { id: 2, label: 'Ter' },
  { id: 3, label: 'Qua' }, { id: 4, label: 'Qui' }, { id: 5, label: 'Sex' },
  { id: 6, label: 'Sáb' }
];

const ANTECEDENCIAS = [
  { value: 0,    label: 'Sem limite' },
  { value: 30,   label: '30 minutos' },
  { value: 60,   label: '1 hora' },
  { value: 120,  label: '2 horas' },
  { value: 180,  label: '3 horas' },
  { value: 240,  label: '4 horas' },
  { value: 480,  label: '8 horas' },
  { value: 720,  label: '12 horas' },
  { value: 1440, label: '24 horas' },
  { value: 2880, label: '48 horas' },
];

function formatAntecedencia(min) {
  if (min == null || min === 0) return 'Sem limite';
  if (min < 60) return `${min} min`;
  const h = Math.round(min / 60);
  return h === 1 ? '1 hora' : `${h} horas`;
}

function formatDias(ids) {
  if (!ids || ids.length === 0) return 'Nenhum';
  if (ids.length === 7) return 'Todos os dias';
  const sorted = [...ids].sort((a, b) => a - b);
  return sorted.map(id => DIAS.find(d => d.id === id)?.label).join(', ');
}

const DIAS_ANTES_OPCOES = [
  { value: 0, label: 'No mesmo dia da ação' },
  { value: 1, label: '1 dia antes da aula' },
  { value: 2, label: '2 dias antes da aula' },
  { value: 3, label: '3 dias antes da aula' },
  { value: 4, label: '4 dias antes da aula' },
  { value: 5, label: '5 dias antes da aula' },
  { value: 6, label: '6 dias antes da aula' },
];

function formatDiasAntes(diasAntes, horario) {
  if (!diasAntes || diasAntes === 0) return null;
  return `${diasAntes} dia${diasAntes > 1 ? 's' : ''} antes às ${horario}`;
}

function formatHorarios(horas) {
  if (!horas || horas.length === 0) return 'Todos os horários';
  return horas.slice().sort().join(', ');
}

const HORAS_DIA = [
  '06:00','07:00','08:00','09:00','10:00','11:00',
  '12:00','13:00','14:00','15:00','16:00','17:00',
  '18:00','19:00','20:00','21:00'
];

const REGRA_VAZIA = {
  nome: '', descricao: '', tipo_regra: 'desagendamento',
  dias_semana: [1, 2, 3, 4, 5], horarios_aplicaveis: [],
  horario_limite: '18:00', antecedencia_minima: 60, dias_antes: 0, ativo: true
};

const Toast = ({ toast }) => {
  if (!toast) return null;
  const isOk = toast.type === 'success';
  return (
    <div style={{
      position: 'fixed', top: 20, right: 20, zIndex: 9999,
      background: isOk ? '#f0fdf4' : '#fef2f2',
      border: `1px solid ${isOk ? '#bbf7d0' : '#fecaca'}`,
      color: isOk ? '#166534' : '#991b1b',
      padding: '12px 20px', borderRadius: 12, fontWeight: 600,
      boxShadow: '0 8px 24px rgba(0,0,0,0.1)', fontSize: '0.875rem'
    }}>{toast.msg}</div>
  );
};

function RegraForm({ initial, onSave, onCancel, isMobile, loading }) {
  const [form, setForm] = useState(initial);

  useEffect(() => { setForm(initial); }, [initial]);

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const toggleDia = (id) => set('dias_semana',
    form.dias_semana.includes(id)
      ? form.dias_semana.filter(d => d !== id)
      : [...form.dias_semana, id]
  );

  const toggleHora = (h) => set('horarios_aplicaveis',
    (form.horarios_aplicaveis || []).includes(h)
      ? (form.horarios_aplicaveis || []).filter(x => x !== h)
      : [...(form.horarios_aplicaveis || []), h]
  );

  const isEdicao = !!initial.id;
  const canSave = form.nome.trim() && form.dias_semana.length > 0;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

      {/* Nome */}
      <div>
        <label style={{ fontSize: '0.78rem', fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
          Nome da regra *
        </label>
        <input
          type="text"
          value={form.nome}
          onChange={e => set('nome', e.target.value)}
          placeholder="Ex: Cancelar até 18h nos dias úteis"
          style={{ width: '100%', padding: '9px 12px', borderRadius: 10, border: '1.5px solid #e2e8f0', fontSize: '0.88rem', outline: 'none', boxSizing: 'border-box' }}
        />
      </div>

      {/* Tipo */}
      <div>
        <label style={{ fontSize: '0.78rem', fontWeight: 700, color: '#475569', display: 'block', marginBottom: 8 }}>
          Tipo
        </label>
        <div style={{ display: 'flex', gap: 8 }}>
          {[
            { id: 'desagendamento', icon: '❌', label: 'Cancelamento' },
            { id: 'agendamento',   icon: '📅', label: 'Agendamento' }
          ].map(t => (
            <button key={t.id} onClick={() => set('tipo_regra', t.id)} style={{
              flex: 1, padding: '10px 8px', borderRadius: 10, border: '2px solid',
              cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600, transition: 'all 0.15s',
              borderColor: form.tipo_regra === t.id ? 'var(--color-primary,#0f5a30)' : '#e2e8f0',
              background: form.tipo_regra === t.id ? 'var(--color-primary,#0f5a30)' : 'white',
              color: form.tipo_regra === t.id ? 'white' : '#475569'
            }}>{t.icon} {t.label}</button>
          ))}
        </div>
      </div>

      {/* Dias */}
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
          <label style={{ fontSize: '0.78rem', fontWeight: 700, color: '#475569' }}>Dias da semana *</label>
          <div style={{ display: 'flex', gap: 6 }}>
            <button onClick={() => set('dias_semana', [1,2,3,4,5])} style={{ fontSize: '0.7rem', color: '#64748b', background: 'none', border: 'none', cursor: 'pointer', padding: '2px 6px', borderRadius: 6, background: '#f1f5f9' }}>Úteis</button>
            <button onClick={() => set('dias_semana', [0,1,2,3,4,5,6])} style={{ fontSize: '0.7rem', color: '#64748b', background: 'none', border: 'none', cursor: 'pointer', padding: '2px 6px', borderRadius: 6, background: '#f1f5f9' }}>Todos</button>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {DIAS.map(d => (
            <button key={d.id} onClick={() => toggleDia(d.id)} style={{
              padding: '7px 12px', borderRadius: 8, border: '2px solid', cursor: 'pointer',
              fontSize: '0.8rem', fontWeight: 700, transition: 'all 0.15s',
              borderColor: form.dias_semana.includes(d.id) ? 'var(--color-primary,#0f5a30)' : '#e2e8f0',
              background: form.dias_semana.includes(d.id) ? 'var(--color-primary,#0f5a30)' : 'white',
              color: form.dias_semana.includes(d.id) ? 'white' : '#64748b'
            }}>{d.label}</button>
          ))}
        </div>
      </div>

      {/* Horários da aula aplicáveis */}
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
          <label style={{ fontSize: '0.78rem', fontWeight: 700, color: '#475569' }}>Horários de aula aplicáveis</label>
          <button onClick={() => set('horarios_aplicaveis', [])} style={{ fontSize: '0.7rem', color: '#64748b', border: 'none', cursor: 'pointer', padding: '2px 6px', borderRadius: 6, background: '#f1f5f9' }}>Todos</button>
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {HORAS_DIA.map(h => (
            <button key={h} onClick={() => toggleHora(h)} style={{
              padding: '5px 10px', borderRadius: 8, border: '2px solid', cursor: 'pointer',
              fontSize: '0.78rem', fontWeight: 700, transition: 'all 0.15s',
              borderColor: (form.horarios_aplicaveis || []).includes(h) ? '#dc2626' : '#e2e8f0',
              background: (form.horarios_aplicaveis || []).includes(h) ? '#fef2f2' : 'white',
              color: (form.horarios_aplicaveis || []).includes(h) ? '#dc2626' : '#64748b'
            }}>{h}</button>
          ))}
        </div>
        <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: 4 }}>
          Sem seleção = aplica a todos os horários. Selecione apenas os horários que devem ser bloqueados.
        </div>
      </div>

      {/* Horário + Antecedência */}
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
        <div>
          <label style={{ fontSize: '0.78rem', fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
            Horário limite
          </label>
          <input
            type="time"
            value={form.horario_limite || ''}
            onChange={e => set('horario_limite', e.target.value)}
            style={{ width: '100%', padding: '9px 12px', borderRadius: 10, border: '1.5px solid #e2e8f0', fontSize: '0.88rem', outline: 'none', boxSizing: 'border-box' }}
          />
          <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: 4 }}>
            Último horário permitido
          </div>
        </div>
        <div>
          <label style={{ fontSize: '0.78rem', fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
            Antecedência mínima
          </label>
          <select
            value={form.antecedencia_minima ?? 0}
            onChange={e => set('antecedencia_minima', parseInt(e.target.value))}
            style={{ width: '100%', padding: '9px 12px', borderRadius: 10, border: '1.5px solid #e2e8f0', fontSize: '0.88rem', outline: 'none', boxSizing: 'border-box', background: 'white' }}
          >
            {ANTECEDENCIAS.map(a => (
              <option key={a.value} value={a.value}>{a.label}</option>
            ))}
          </select>
          <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: 4 }}>
            Tempo mínimo antes da aula
          </div>
        </div>
      </div>

      {/* Dias antes — só aparece quando horário limite está preenchido */}
      {form.horario_limite && (
        <div>
          <label style={{ fontSize: '0.78rem', fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
            📅 Verificar horário limite em relação à aula
          </label>
          <select
            value={form.dias_antes ?? 0}
            onChange={e => set('dias_antes', parseInt(e.target.value))}
            style={{ width: '100%', padding: '9px 12px', borderRadius: 10, border: '1.5px solid #e2e8f0', fontSize: '0.88rem', outline: 'none', boxSizing: 'border-box', background: 'white' }}
          >
            {DIAS_ANTES_OPCOES.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
          {(form.dias_antes ?? 0) > 0 && (
            <div style={{ marginTop: 8, padding: '8px 12px', background: '#fffbeb', borderRadius: 8, border: '1px solid #fde68a', fontSize: '0.78rem', color: '#92400e' }}>
              ⚠️ O prazo será verificado <strong>{form.dias_antes} dia{form.dias_antes > 1 ? 's' : ''} antes</strong> da aula às <strong>{form.horario_limite}</strong>.
              <br/>Exemplo: aula no sábado com 1 dia antes → prazo até sexta às {form.horario_limite}.
            </div>
          )}
        </div>
      )}

      {/* Descrição */}
      <div>
        <label style={{ fontSize: '0.78rem', fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
          Descrição (opcional)
        </label>
        <textarea
          value={form.descricao || ''}
          onChange={e => set('descricao', e.target.value)}
          rows={2}
          placeholder="Explique o objetivo desta regra…"
          style={{ width: '100%', padding: '9px 12px', borderRadius: 10, border: '1.5px solid #e2e8f0', fontSize: '0.85rem', outline: 'none', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit' }}
        />
      </div>

      {/* Ativo (só na edição) */}
      {isEdicao && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', background: '#f8fafc', borderRadius: 10, border: '1px solid #e2e8f0' }}>
          <span style={{ fontSize: '0.85rem', fontWeight: 600, color: '#1e293b' }}>Regra ativa</span>
          <button onClick={() => set('ativo', !form.ativo)} style={{
            width: 44, height: 24, borderRadius: 12, border: 'none', cursor: 'pointer',
            background: form.ativo ? 'var(--color-primary,#0f5a30)' : '#cbd5e1',
            position: 'relative', transition: 'all 0.2s', flexShrink: 0
          }}>
            <span style={{ position: 'absolute', top: 2, width: 20, height: 20, borderRadius: '50%', background: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.2)', left: form.ativo ? '22px' : '2px', transition: 'left 0.2s' }} />
          </button>
        </div>
      )}

      {/* Botões */}
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', paddingTop: 4 }}>
        {onCancel && (
          <button onClick={onCancel} style={{ padding: '9px 18px', borderRadius: 10, border: '1.5px solid #e2e8f0', background: 'white', color: '#64748b', fontSize: '0.85rem', fontWeight: 600, cursor: 'pointer' }}>
            Cancelar
          </button>
        )}
        <button
          onClick={() => onSave(form)}
          disabled={loading || !canSave}
          style={{
            padding: '9px 22px', borderRadius: 10, border: 'none',
            background: canSave ? 'var(--color-primary,#0f5a30)' : '#e2e8f0',
            color: canSave ? 'white' : '#94a3b8', fontSize: '0.85rem', fontWeight: 700,
            cursor: canSave && !loading ? 'pointer' : 'not-allowed', transition: 'all 0.15s'
          }}
        >
          {loading ? 'Salvando…' : isEdicao ? '💾 Salvar alterações' : '+ Criar regra'}
        </button>
      </div>
    </div>
  );
}

function RegraCard({ regra, onToggle, onEdit, onDelete, isMobile }) {
  const [confirmDelete, setConfirmDelete] = useState(false);

  const tipoColor = regra.tipo_regra === 'desagendamento'
    ? { bg: '#fef2f2', border: '#fecaca', text: '#dc2626', label: 'Cancelamento' }
    : { bg: '#eff6ff', border: '#bfdbfe', text: '#2563eb', label: 'Agendamento' };

  return (
    <div style={{
      background: 'white', borderRadius: 14, border: '1px solid #e2e8f0',
      borderLeft: `4px solid ${regra.ativo ? 'var(--color-primary,#0f5a30)' : '#cbd5e1'}`,
      padding: isMobile ? '14px' : '16px 20px',
      opacity: regra.ativo ? 1 : 0.65, transition: 'opacity 0.2s'
    }}>
      {/* Linha 1: nome + badges + ações */}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span style={{ fontWeight: 700, fontSize: '0.92rem', color: '#0f172a' }}>{regra.nome}</span>
            <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: 20, background: tipoColor.bg, border: `1px solid ${tipoColor.border}`, color: tipoColor.text }}>
              {tipoColor.label}
            </span>
            <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: 20, background: regra.ativo ? '#f0fdf4' : '#f8fafc', border: `1px solid ${regra.ativo ? '#bbf7d0' : '#e2e8f0'}`, color: regra.ativo ? '#166534' : '#94a3b8' }}>
              {regra.ativo ? '● Ativa' : '○ Inativa'}
            </span>
          </div>
          {regra.descricao && (
            <p style={{ margin: '4px 0 0', fontSize: '0.8rem', color: '#64748b' }}>{regra.descricao}</p>
          )}
        </div>

        {/* Ações */}
        <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
          <button onClick={() => onToggle(regra)} title={regra.ativo ? 'Desativar' : 'Ativar'} style={{
            padding: '5px 10px', borderRadius: 8, border: '1px solid #e2e8f0',
            background: 'white', cursor: 'pointer', fontSize: '0.78rem', fontWeight: 600,
            color: regra.ativo ? '#f59e0b' : '#10b981'
          }}>{regra.ativo ? 'Desativar' : 'Ativar'}</button>
          <button onClick={() => onEdit(regra)} title="Editar" style={{
            padding: '5px 10px', borderRadius: 8, border: '1px solid #e2e8f0',
            background: 'white', cursor: 'pointer', fontSize: '0.78rem', fontWeight: 600, color: '#3b82f6'
          }}>✏️</button>
          {!confirmDelete
            ? <button onClick={() => setConfirmDelete(true)} title="Excluir" style={{ padding: '5px 10px', borderRadius: 8, border: '1px solid #fecaca', background: '#fff1f1', cursor: 'pointer', fontSize: '0.78rem', fontWeight: 600, color: '#dc2626' }}>🗑️</button>
            : <div style={{ display: 'flex', gap: 4 }}>
                <button onClick={() => onDelete(regra.id)} style={{ padding: '5px 10px', borderRadius: 8, border: 'none', background: '#dc2626', cursor: 'pointer', fontSize: '0.78rem', fontWeight: 700, color: 'white' }}>Confirmar</button>
                <button onClick={() => setConfirmDelete(false)} style={{ padding: '5px 8px', borderRadius: 8, border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', fontSize: '0.78rem', color: '#64748b' }}>✕</button>
              </div>
          }
        </div>
      </div>

      {/* Linha 2: detalhes */}
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', fontSize: '0.8rem', color: '#475569' }}>
        <span>📅 {formatDias(regra.dias_semana)}</span>
        {regra.horarios_aplicaveis?.length > 0 && (
          <span>⏰ Aulas: {formatHorarios(regra.horarios_aplicaveis)}</span>
        )}
        {regra.horario_limite && (
          <span>
            🕐 {regra.dias_antes > 0
              ? formatDiasAntes(regra.dias_antes, regra.horario_limite)
              : `Até ${regra.horario_limite}`}
          </span>
        )}
        {regra.antecedencia_minima != null && regra.antecedencia_minima > 0 && (
          <span>⏱ {formatAntecedencia(regra.antecedencia_minima)} de antecedência</span>
        )}
      </div>
    </div>
  );
}

export const GerenciadorRegras = ({ createApi, isMobile = false }) => {
  const [regras, setRegras] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [regraEditando, setRegraEditando] = useState(null);

  const showToast = useCallback((type, msg) => {
    setToast({ type, msg });
    setTimeout(() => setToast(null), 3500);
  }, []);

  const carregar = useCallback(async () => {
    setLoading(true);
    try {
      const api = createApi();
      const res = await api.get('/admin/regras-agendamento');
      setRegras(res.data);
    } catch {
      showToast('error', 'Erro ao carregar regras');
    } finally {
      setLoading(false);
    }
  }, [createApi, showToast]);

  useEffect(() => { carregar(); }, [carregar]);

  const handleCriar = async (form) => {
    setSaving(true);
    try {
      const api = createApi();
      const res = await api.post('/admin/regras-agendamento', form);
      setRegras(prev => [...prev, res.data.regra]);
      setMostrarForm(false);
      showToast('success', '✅ Regra criada com sucesso!');
    } catch (err) {
      showToast('error', err.response?.data?.error || 'Erro ao criar regra');
    } finally {
      setSaving(false);
    }
  };

  const handleEditar = async (form) => {
    setSaving(true);
    try {
      const api = createApi();
      const res = await api.put(`/admin/regras-agendamento/${form.id}`, form);
      setRegras(prev => prev.map(r => r.id === form.id ? res.data.regra : r));
      setRegraEditando(null);
      showToast('success', '✅ Regra atualizada!');
    } catch (err) {
      showToast('error', err.response?.data?.error || 'Erro ao salvar');
    } finally {
      setSaving(false);
    }
  };

  const handleToggle = async (regra) => {
    try {
      const api = createApi();
      const res = await api.put(`/admin/regras-agendamento/${regra.id}`, { ativo: !regra.ativo });
      setRegras(prev => prev.map(r => r.id === regra.id ? res.data.regra : r));
    } catch {
      showToast('error', 'Erro ao atualizar regra');
    }
  };

  const handleExcluir = async (id) => {
    try {
      const api = createApi();
      await api.delete(`/admin/regras-agendamento/${id}`);
      setRegras(prev => prev.filter(r => r.id !== id));
      showToast('success', 'Regra excluída');
    } catch {
      showToast('error', 'Erro ao excluir');
    }
  };

  const grupos = [
    { tipo: 'desagendamento', icon: '❌', label: 'Regras de Cancelamento' },
    { tipo: 'agendamento',    icon: '📅', label: 'Regras de Agendamento' },
  ];

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", color: '#1e293b' }}>
      <Toast toast={toast} />

      {/* Header */}
      <div style={{ padding: isMobile ? '16px' : '20px 28px', borderBottom: '1px solid #f1f5f9', background: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <div>
          <h2 style={{ margin: 0, fontSize: isMobile ? '1.05rem' : '1.15rem', fontWeight: 700 }}>📋 Regras de Agendamento</h2>
          <p style={{ margin: '3px 0 0', fontSize: '0.8rem', color: '#64748b' }}>Controla quando alunos podem agendar ou cancelar aulas</p>
        </div>
        {!mostrarForm && !regraEditando && (
          <button onClick={() => setMostrarForm(true)} style={{ padding: '9px 18px', borderRadius: 10, border: 'none', background: 'var(--color-primary,#0f5a30)', color: 'white', fontSize: '0.85rem', fontWeight: 700, cursor: 'pointer' }}>
            + Nova Regra
          </button>
        )}
      </div>

      <div style={{ padding: isMobile ? '16px' : '24px 28px', display: 'flex', flexDirection: 'column', gap: 24 }}>

        {/* Formulário nova regra */}
        {mostrarForm && !regraEditando && (
          <div style={{ background: '#f8fafc', borderRadius: 14, border: '1.5px solid #e2e8f0', padding: isMobile ? '16px' : '20px 24px' }}>
            <h3 style={{ margin: '0 0 16px', fontSize: '0.95rem', fontWeight: 700, color: '#0f172a' }}>Nova Regra</h3>
            <RegraForm
              initial={REGRA_VAZIA}
              onSave={handleCriar}
              onCancel={() => setMostrarForm(false)}
              isMobile={isMobile}
              loading={saving}
            />
          </div>
        )}

        {/* Formulário de edição */}
        {regraEditando && (
          <div style={{ background: '#eff6ff', borderRadius: 14, border: '1.5px solid #bfdbfe', padding: isMobile ? '16px' : '20px 24px' }}>
            <h3 style={{ margin: '0 0 16px', fontSize: '0.95rem', fontWeight: 700, color: '#1e40af' }}>✏️ Editando: {regraEditando.nome}</h3>
            <RegraForm
              initial={regraEditando}
              onSave={handleEditar}
              onCancel={() => setRegraEditando(null)}
              isMobile={isMobile}
              loading={saving}
            />
          </div>
        )}

        {/* Lista agrupada */}
        {loading && regras.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '3rem', color: '#94a3b8' }}>Carregando…</div>
        ) : (
          grupos.map(grupo => {
            const lista = regras.filter(r => r.tipo_regra === grupo.tipo);
            return (
              <div key={grupo.tipo}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                  <span style={{ fontSize: '0.8rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    {grupo.icon} {grupo.label}
                  </span>
                  <span style={{ fontSize: '0.75rem', background: '#f1f5f9', color: '#94a3b8', borderRadius: 20, padding: '1px 8px', fontWeight: 600 }}>
                    {lista.length}
                  </span>
                </div>
                {lista.length === 0 ? (
                  <div style={{ padding: '20px', background: '#f8fafc', borderRadius: 12, border: '1.5px dashed #e2e8f0', textAlign: 'center', fontSize: '0.82rem', color: '#94a3b8' }}>
                    Nenhuma regra de {grupo.tipo === 'desagendamento' ? 'cancelamento' : 'agendamento'} configurada
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {lista.map(regra => (
                      <RegraCard
                        key={regra.id}
                        regra={regra}
                        onToggle={handleToggle}
                        onEdit={r => { setMostrarForm(false); setRegraEditando(r); }}
                        onDelete={handleExcluir}
                        isMobile={isMobile}
                      />
                    ))}
                  </div>
                )}
              </div>
            );
          })
        )}

        {/* Info */}
        <div style={{ background: '#eff6ff', borderRadius: 12, padding: '14px 18px', border: '1px solid #bfdbfe', fontSize: '0.8rem', color: '#1e40af', lineHeight: 1.7 }}>
          <strong>ℹ️ Como as regras funcionam:</strong> Todas as regras do tipo aplicável ao dia e horário da aula são verificadas. Se qualquer uma bloquear a ação, ela é impedida.
          <strong> Horários de aula aplicáveis</strong> = restringe a regra a horários específicos (ex: 07:00 e 08:00). Vazio = todos os horários.
          <strong> Horário limite</strong> = último horário permitido (use "Dias antes" para verificar no dia anterior).
          <strong> Antecedência mínima</strong> = tempo mínimo antes da aula começar.
        </div>
      </div>
    </div>
  );
};
